import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-company-share-report', standalone: true, imports: [CommonModule],
  templateUrl: './company-share-report.component.html',
})
export class CompanyShareReportComponent {
  @Input() report: any;
  @Input() daily = false;
  total(row: any, key: string) { return (row.days || []).reduce((sum: number, day: any) => sum + Number(day[key] || 0), 0); }
}
